import React from 'react'
import './FileInput.scss'

export default ({ label, name, id, onChange, errorMessage }) => {

return (
    <>
        <label for={name} className='hw-label'>
            {label}
            </label>
        <input
            type='file'
            id={id}
            className='fileInput'
            name={name}
            onChange={onChange}
            accept='image/*, .doc, .docx,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf '
        />
        {errorMessage && (
            <div className='fileInput-error hw-error hw-error--align-left hw-error--indented'>
                {errorMessage}
            </div>
        )}
        
    </>
)
        }
